import { useMutation } from '@apollo/client';
import type { DeleteScimTokenMutation } from '@risksmart-app/web-graphql-client/generated/graphql';
import { DeleteScimTokenDocument } from '@risksmart-app/web-graphql-client/generated/graphql';

import { useIsFeatureFlagEnabled } from '@/hooks/useIsFeatureFlagEnabled';
import { evictField } from '@/utils/graphqlUtils';

import { useDeleteScimTokenTRPC } from './useDeleteScimTokenTRPC';

type DeleteScimTokenInput = { keyId: string };

export const useDeleteScimToken = () => {
  const trpcEnabled = useIsFeatureFlagEnabled('trpc');

  const [deleteScimTokenGraphQL, graphqlState] = useMutation(
    DeleteScimTokenDocument,
    {
      update: (cache) => {
        evictField(cache, 'getScimConfig');
      },
    }
  );

  const trpcMutation = useDeleteScimTokenTRPC();

  const deleteScimToken = async (
    variables: DeleteScimTokenInput
  ): Promise<DeleteScimTokenMutation> => {
    if (trpcEnabled) {
      return trpcMutation.deleteScimToken(variables);
    }

    const result = await deleteScimTokenGraphQL({ variables });
    if (!result.data) {
      throw new Error('Failed to revoke SCIM token');
    }

    return result.data;
  };

  return {
    deleteScimToken,
    loading: trpcEnabled ? trpcMutation.loading : graphqlState.loading,
    error: trpcEnabled ? trpcMutation.error : graphqlState.error,
  };
};
